// Display name normalization and validation
export const normalizeDisplayName = (name) => {
  return name.trim().toLowerCase();
};

export const validateDisplayName = (name) => {
  const trimmed = name.trim();
  if (trimmed.length < 2) {
    return 'Display name must be at least 2 characters';
  }
  if (trimmed.length > 30) {
    return 'Display name must be less than 30 characters';
  }
  if (!/^[a-zA-Z0-9\s]+$/.test(trimmed)) {
    return 'Display name can only contain letters, numbers, and spaces';
  }
  return null;
};
